import React, { useState,useEffect,useMemo } from "react";
import { useDispatch } from "react-redux";
import { TabContext, TabPanel, TabList } from '@mui/lab';
import {Box,Grid,Button,InputLabel,Select,OutlinedInput,MenuItem,FormControl,Tab} from "@mui/material";
import { fetchData, postData } from "../../../../redux/apiSlice";
import swal from "sweetalert";
import { DateRangePicker,createStaticRanges } from 'react-date-range';
import { calendarFilter,useDateSelectionRange,getInitialSelectionRange } from '../../../../Components/CommonFormula';
import Enrolled from '../../../../Components/MyLeads/AffiliateMyLeads/Enrolled';
import Upgraded from '../../../../Components/MyLeads/AffiliateMyLeads/Upgraded';
const LeadTab = ({company_id,handleFreezStart,handleFreezStop,loginUser}) => {
  const dispatch = useDispatch();
  const [value, setValue] = React.useState("enrolled");
  const { selectionRange, setSelectionRange, startDate, endDate,clearFilter } = useDateSelectionRange(getInitialSelectionRange('true'))

  const handleChange = (event, newValue) => {
      setValue(newValue);
  };
  
  const sideBar = calendarFilter();
  const staticRanges = [
      // ...defaultStaticRanges,
      ...createStaticRanges(sideBar)
  ];
  const [enrolled1, setEnrolled] = useState([]);
  const [upgraded1, setUpgraded] = useState([]);

  const GetMyLeads = async () => {
    handleFreezStart();
    let apiUrl;
     if(loginUser.roles_id  <= 2) {
      apiUrl = '/fetchLeadReport/admin/'+ company_id;
     }else{
        apiUrl = '/fetchLeadReport';
     }
    const args = {
      fromDate: startDate,
      toDate: endDate
    }
    const res = await dispatch(postData({ apiUrl, args })).unwrap();
    if (res) {
      if (res.success == true) {
        handleFreezStop();
        setEnrolled(res.data.enrolledMembers);
        setUpgraded(res.data.upgradedMembers);
      } else {
        handleFreezStop();
      }
    } else {
      swal({
        title: "Failed",
        text: "Network Error",
        icon: "error",
        button: "Ok",
      });
    }
  }

  
  useEffect(() => {
      GetMyLeads();
  }, []);

  return (
    <>
      <Box sx={{ width: "100%", typography: 'body1' }}>
        <Grid item lg={5} md={5} xs={6} sm={6}>
          <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} >
            <Grid item lg={6} md={6} sm={8} xs={8}>
              <FormControl fullWidth size='small'>
                <InputLabel id="demo-multiple-name-label">Select Date Range</InputLabel>
                <Select
                  labelId="demo-multiple-name-label"
                  id="demo-multiple-name"
                  value="date"
                  input={<OutlinedInput label="Select Date Range" />}
                >
                  <MenuItem value="date" >{startDate ? <>{startDate} To {endDate}</> : 'Select Date Range'}</MenuItem>
                  <DateRangePicker
                    className='custom-date-picker'
                    onChange={item => setSelectionRange([item.selection])}
                    showSelectionPreview={true}
                    moveRangeOnFirstSelection={false}
                    months={2}
                    ranges={selectionRange}
                    direction="horizontal"
                    maxDate={new Date()}
                    staticRanges={staticRanges}
                  />
                </Select>
                <Button onClick={clearFilter} >Clear Dates</Button>
              </FormControl>
            </Grid>
            <Grid item lg={6} md={6} sm={4} xs={4}>
              <Button variant="contained" color="success" sx={{ minWidth: 150 }}
                onClick={() => {
                    GetMyLeads();
                }}>
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ justifyContent: 'space-between' }}>
              <Grid item lg={7} md={7} xs={6} sm={6}>
                <TabList onChange={handleChange} aria-label="lab API tabs example" >
                  <Tab  value="enrolled" label="Enrolled" />
                  <Tab   value="upgraded" label="Upgraded" />
                </TabList>
              </Grid>
              
            </Grid>
          </Box>
          {value === "enrolled" && <Enrolled props={enrolled1} /> }
          {value === "upgraded" && <Upgraded props={upgraded1} />}

        </TabContext>
      </Box>
    </>
       
  );
};

export default LeadTab;